import React from 'react';
import StrokeBox from '../../../../dashboard/src/components/common/StrokeBox';
import {
  Center,
  VStack,
  Button,
  Text,
  HStack,
  Divider,
  Box,
} from '@wegroup/design-system';

interface Props {
  icon: JSX.Element;
  title: string;
  description?: string;
  onClick: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  buttonText?: string;
  'data-test-id'?: string;
}

const CompanySuccessActionBox: React.FC<React.PropsWithChildren<Props>> = ({
  icon,
  title,
  description,
  isLoading,
  isDisabled,
  onClick,
  buttonText,
  'data-test-id': dataTestId,
}) => {
  return (
    <StrokeBox
      as={VStack}
      spacing="3"
      align="stretch"
      divider={<Divider borderColor="gray.50" />}
      boxShadow="level3"
    >
      <HStack spacing="4">
        <Center
          bg={'gray.strokeAndBg'}
          flexShrink={0}
          borderRadius="md"
          w="12"
          h="12"
          color={'gray.300'}
        >
          {icon}
        </Center>
        <Text textStyle="normalBodyMedium" flexGrow={1}>
          {title}
        </Text>
      </HStack>
      <VStack align="stretch" flexGrow={1} spacing="3">
        {description && (
          <Box
            dangerouslySetInnerHTML={{ __html: description }}
            flexGrow={1}
            color="gray.500"
            sx={{
              strong: { color: 'black' },
              a: { color: 'primary.500' },
              p: {
                marginBottom: 2,
              },
            }}
          />
        )}
        <Button
          isLoading={isLoading}
          isDisabled={isDisabled}
          variant="secondary"
          rightIcon={!buttonText ? icon : undefined}
          onClick={onClick}
          data-test-id={dataTestId}
        >
          {buttonText || title}
        </Button>
      </VStack>
    </StrokeBox>
  );
};

export default CompanySuccessActionBox;
